


import launch from './launch';
import languageSelect from './languageselect';
import tourSelect from './tourselect';
import tour from './tour';
import siteObject from './siteobject';
import floorPlan from './floorplan';
import { IRoute, IRouteName, IRouter } from '../interface/route';
import { IRouteLanguageSelect } from './languageselect/interface';
import { IRouteLaunch } from './launch/interface';
import { IRouteTourSelect } from './tourselect/interface';
import { IRouteTour } from './tour/interface';
import { IRouteSiteObject } from './siteobject/interface';
import { IRouteFloorplan } from './floorplan/interface';
import { IConfigRoutePath, IConfigRoute } from '../interface/config';
import { IQueryURL } from '../interface/util';

import LocationHistory, { ILocationHistory } from '../LocationHistory';

interface IRouterPrv extends IRouter {
    routes: {
        launch: IRoute<IRouteLaunch>,
        languageSelect: IRoute<IRouteLanguageSelect>,
        tourSelect: IRoute<IRouteTourSelect>,
        tour: IRoute<IRouteTour>,
        siteObject: IRoute<IRouteSiteObject>,
        floorPlan: IRoute<IRouteFloorplan>,
    },
    history?: ILocationHistory;
}


function _route(router: IRouterPrv, name: IRouteName): IRoute<any>|null {
    let route: IRoute<any> | null = null;
    switch (name) {
        case IRouteName.Launch:
            route = router.routes.launch;
            break;

        case IRouteName.LanguageSelect:
            route = router.routes.languageSelect;
            break;

        case IRouteName.TourSelect:
            route = router.routes.tourSelect;
            break;

        case IRouteName.Tour:
            route = router.routes.tour;
            break;

        case IRouteName.SiteObject:
            route = router.routes.siteObject;
            break;

        case IRouteName.FloorPlan:
            route = router.routes.floorPlan;
            break;
        
        default:
            throw Error(`Unknown router route: ${name}`);
    }
    return route;
}

function Router(config: IConfigRoute, query: IQueryURL): IRouter {
    const routes = config.routes
    const router: IRouterPrv = {
        routes: {
            launch: launch(routes[IConfigRoutePath.Launch], query),
            languageSelect: languageSelect(routes[IConfigRoutePath.LanguageSelect], query),
            tourSelect: tourSelect(routes[IConfigRoutePath.TourSelect], query),
            tour: tour(routes[IConfigRoutePath.Tour], query),
            siteObject: siteObject(routes[IConfigRoutePath.SiteObject], query),
            floorPlan: floorPlan(routes[IConfigRoutePath.FloorPlan], query),
        },

        push: function(this: IRouterPrv, name: IRouteName, history: any, args: any, options?: {replace?: boolean}) {
            if ( !this.history ) { this.history = LocationHistory(history); }

            const self = this;

            const route: IRoute<any> | null = _route(this, name);

            if ( !route ) { return; }

            route.push(history, args)
                .then(function(result) {
                    if ( result.didLaunchAction && route ) { 
                        /* done */
                    } else if ( result.alternativeRouteRequested ) {
                        self.push(result.alternativeRouteRequested, history, result.alternativeRoutePayload ?? {});    
                    }
                })
                .catch(error => console.error(error));
        },

        popTo: function(this: IRouterPrv, name: IRouteName, history: any, args: any): boolean {
            if ( !this.history ) { this.history = LocationHistory(history); }

            const routeTarget: IRoute<any> | null = _route(this, name);

            if ( !routeTarget ) { return false; }

            const curIdx = this.history?.findFirstPathPrefix(routeTarget.paths) ?? -1;

            if ( curIdx >= 0 ) {
                const popCount = ((this.history?.length() ?? -1) - curIdx) - 1;
                history.go(-popCount);
            }

            const didPop = curIdx >= 0; 
            return didPop;
        },

        pop: function(this: IRouterPrv, history: any, args: any): boolean {
            return this.popCount(1, history, args);
        },

        popCount: function(this: IRouterPrv, popCount: number, history: any, args: any): boolean {
            if ( !this.history ) { this.history = LocationHistory(history); }

            const canPop = popCount <= (this.history?.length() ?? -1) 

            if ( canPop ) {
                history.go(-popCount);
            }

            return canPop;
        },
    
        allRoutes: function(this: IRouterPrv) {
            return Object.values(this.routes);
        }
    }
    
    return router as IRouter;
}

export default Router;